'use strict'
const merge = require('webpack-merge')
module.exports = merge({
    NODE_ENV: 'production',
    API_URL: 'http://api.huakai.com',
    APIP_URL: 'http://m.huakai.com',
    APIW_URL: 'http://www.huakai.com',
    APIH_URL: 'http://www.huakai.com',
    APIT_URL: 'http://test.huakai.com',
    PATH_URL: 'http://172.16.0.1:8080/',
})
